import React, { ReactNode } from 'react';
import FooterLink from './FooterLink';

interface Props {
  href: string;
  icon: ReactNode;
}

const SvgIconLink = ({ href, icon }: Props) => (
  <FooterLink href={href}>{icon}</FooterLink>
);

export default SvgIconLink;
